import { render, staticRenderFns } from "./index.vue?vue&type=template&id=19db6d30&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=19db6d30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19db6d30",
  null
  
)

export default component.exports